import React, { useEffect, useRef } from 'react';
import { Grid16 } from '@carbon/icons-react';
import { useDispatch, connect } from 'react-redux';
import { RootState } from 'redux/root.reducer';
import { CFCProps } from 'types';
import PropTypes from 'prop-types';
import { Button, ButtonKind, ButtonSize } from 'carbon-components-react';
import { TooltipPosition } from 'carbon-components-react/typings/shared';
import { isMobile } from 'react-device-detect';
import { setIsOpenMapStylePanel } from 'redux/map/actions';

const MapStyleController: React.FC<Props> = ({
  isOpen,
  buttonSize,
  buttonKind,
  buttonClassName,
  buttonDisabled,
  buttonIconDescription,
  buttonTooltipPosition,
  onOpenBasemap
}) => {
  const dispatch = useDispatch();
  const basemapButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!isOpen) {
      basemapButtonRef?.current?.blur();
    }
    onOpenBasemap && onOpenBasemap(isOpen);
  }, [isOpen, onOpenBasemap]);

  return (
    <div
      className={`map-style-controller-container${
        isMobile ? ' is-mobile' : ''
      }`}
    >
      <Button
        renderIcon={Grid16}
        iconDescription={
          buttonIconDescription === null ? undefined : buttonIconDescription
        }
        tooltipPosition={buttonTooltipPosition}
        hasIconOnly
        kind={buttonKind}
        size={buttonSize}
        disabled={buttonDisabled === null ? undefined : buttonDisabled}
        className={buttonClassName === null ? undefined : buttonClassName}
        onClick={() => dispatch(setIsOpenMapStylePanel(!isOpen))}
        ref={basemapButtonRef}
      />
    </div>
  );
};

const propTypes = {
  buttonDisabled: PropTypes.bool,
  buttonClassName: PropTypes.string,
  buttonIconDescription: PropTypes.string,
  onOpenBasemap: PropTypes.func
};

type carbinProps = {
  buttonKind?: ButtonKind;
  buttonSize?: ButtonSize;
  buttonTooltipPosition?: TooltipPosition;
};

type ownProps = PropTypes.InferProps<typeof propTypes>;

MapStyleController.defaultProps = {
  buttonSize: 'field',
  buttonKind: 'tertiary',
  buttonDisabled: false,
  buttonClassName: 'map-style-controller-button bx--tooltip--hidden',
  buttonIconDescription: 'Map style',
  buttonTooltipPosition: 'right'
};

const mapStateToProps = ({ mapCache }: RootState) => ({
  isOpen: mapCache.isOpenBaseMapPanel
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector> & ownProps & carbinProps;

export default React.memo(connector(MapStyleController));
